/**
 * _navigation.js
 * @author      Marc-André Appel <marc-andre@sudimage.fr>
 * @copyright   2017 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        https://www.sudimage.fr
 * @created     02/06/2017
 */

/* globals Scrolling */

(() => {
    "use strict";

    let multilevel = () => {
        $('a.dropdown-toggle', $navigation).on('click', function (event) {
            let li;
            let ul = $(this).parent().parent();
            if ( ! ul.hasClass('nav')) {
                event.preventDefault();
                $('li', ul).each(function () {
                    if ($(this).hasClass('open')) {
                        $(this).removeClass('open');
                    }
                });
                li = $(this).parent();
                if ( ! li.hasClass('open')) {
                    li.addClass('open');
                } else {
                    li.removeClass('open');
                }
                if (li.hasClass('pull-left')) {
                    $(this).next().css({
                        left: '-' + li.width() + 'px',
                        marginLeft: '-' + 36 + 'px'
                    });
                } else {
                    $(this).next().css({
                        left: li.width() + 'px'
                    });
                }

                return false;
            }
        });
    };

    let centered = () => {
        let availableWidth = $('.container', $navigation).width();
        let navigationWidth = 0;
        $('.navbar-nav > li', $navigation).each(function () {
            navigationWidth += $(this).outerWidth();
        });
        if (availableWidth > navigationWidth) {
            $('.navbar-nav', $navigation).css({
                marginLeft: Math.floor((availableWidth - navigationWidth) / 2)
            });
        }
    };

    const fixed = () => {
        let breakpoint = $navigation.offset().top;
        let containerHeight = 36;
        let navigationTop = 0;
        const ccmToolbar = 48;

        if ($html.hasClass('ccm-toolbar-visible')) {
            navigationTop = ccmToolbar;
            breakpoint -= ccmToolbar;
        }

        $window.scroll(() => {
            let scrollPos = $('html').scrollTop() || $('body').scrollTop();

            if (scrollPos > breakpoint) {
                $navigation
                    .addClass('navbar-fixed-top')
                    .css({
                        top: navigationTop
                    });
                $('.navbar-container').css({
                    height: containerHeight
                });
            } else {
                $('.navbar-container').css({
                    height: 'auto'
                });
                $navigation
                    .removeClass('navbar-fixed-top')
                    .css({
                        top: 'initial'
                    });
            }
        });
    };

    if ( ! CCM_EDIT_MODE) {
        $document.ready(() => {
            if (window.isNotMobile && $window.width() >= 768) {
                centered();
                // multilevel();
                // fixed();
                $window.resize(() => {
                    // multilevel();
                    centered();
                    // fixed();
                });
            }
        });
    }
})($window, $document, $navigation, $html);